/* eslint-disable prettier/prettier */
/**
 * Toggle Component
 */

// Create the events and event listener
const createToggleEvents = element => {
  const toggleTrigger = element.querySelector('[data-toggle="trigger"]')
  const toggleContent = element.querySelector('[data-toggle="content"]')

  if (element.contains(toggleTrigger)) {

    toggleTrigger.addEventListener('click', () => {
      // Toggle content display property
      toggleContent.classList.toggle('display-none')
      // Toggle aria-expanded events
      toggleAriaExpandedState(toggleTrigger)
      // Toggle aria-hidden events
      toggleAriaHiddenState(toggleContent)

    })
  }
}

// Toggle components aria expanded states
const toggleAriaExpandedState = toggleTrigger => {
  if (toggleTrigger.hasAttribute('aria-expanded')) {
    // corresponding items aria attribute
    const isContentExpanded = toggleTrigger.getAttribute('aria-expanded')
    // set it true or false depending
    toggleTrigger.setAttribute(
      'aria-expanded',
      isContentExpanded === 'false' ? 'true' : 'false'
    )
  } else {
    // If it doesn't have it then set it to false initially
    toggleTrigger.setAttribute('aria-expanded', 'false')
  }
}

// Toggle components aria hidden states
const toggleAriaHiddenState = toggleContent => {
  if (toggleContent.hasAttribute('aria-hidden')) {
    // corresponding items aria attribute
    const isContentHidden = toggleContent.getAttribute('aria-hidden')
    // set it true or false depending
    toggleContent.setAttribute(
      'aria-hidden',
      isContentHidden === 'true' ? 'false' : 'true'
    )
  } else {
    // If hidden isn't set to true set it
    toggleContent.setAttribute('aria-hidden', 'true')
  }
}

// Bind events to all individual toggle type components on page
const bindToggleEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createToggleEvents(element)
    })
  }
}

bindToggleEvents('[data-toggle="container"]')
